var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLido = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 32,
    viewBox: "0 0 110 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2265_11081)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2265_11081",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 6,
    width: 80,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.8913 6H15V27H94.8913V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2265_11081)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3994 6L27.6288 14.1364L22.3994 17.1637L17.1699 14.1364L22.3994 6ZM18.7696 13.7498L22.3994 8.10512L26.0291 13.7498L22.3994 15.8503L18.7696 13.7498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3943 18.9518L16.3276 15.4402L16.1639 15.6963C14.2976 18.6025 14.7139 22.4076 17.1649 24.848C20.0509 27.717 24.7331 27.717 27.6237 24.848C30.0794 22.4076 30.4957 18.6025 28.6247 15.6963L28.461 15.4402L22.3943 18.9518Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6122 22.0448H41.7129V10.9556H43.8178V20.0886H48.6122V22.0448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1928 22.0448H57.0879V10.9556H59.1928V22.0448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7246 22.0448V10.9556H71.3307C71.878 10.9556 72.3222 10.9742 72.6592 11.0161C73.5293 11.1186 74.2821 11.426 74.9089 11.9336C75.5453 12.4413 76.0269 13.0933 76.3542 13.8897C76.6866 14.6815 76.85 15.5524 76.85 16.5025C76.85 17.4526 76.6866 18.3235 76.3542 19.1199C76.0224 19.9117 75.5407 20.559 74.9089 21.0667C74.2775 21.5744 73.5293 21.8817 72.6592 21.9842C72.3177 22.0261 71.8735 22.0448 71.3307 22.0448H67.7246ZM71.3307 20.0747C71.878 20.0747 72.2802 20.0467 72.5377 19.9955C73.0006 19.9023 73.3887 19.6834 73.6977 19.3388C74.0109 18.9895 74.2447 18.5703 74.3944 18.0767C74.5487 17.5783 74.6286 17.052 74.6286 16.4978C74.6286 15.9436 74.5487 15.3941 74.3898 14.8957C74.2355 14.3974 74.0018 13.9782 73.6836 13.6382C73.375 13.2983 72.9915 13.084 72.5377 13.0001C72.2802 12.9489 71.878 12.921 71.3307 12.921H69.862V20.07H71.3307V20.0747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4923 22.2771C88.3935 22.2771 87.4389 22.0395 86.6203 21.5599C85.8068 21.0755 85.18 20.4002 84.7399 19.5246C84.3053 18.6536 84.0898 17.643 84.0898 16.4973C84.0898 15.3516 84.3053 14.3409 84.7399 13.47C85.18 12.5991 85.8068 11.9238 86.6203 11.4441C87.4343 10.9597 88.3935 10.7222 89.4923 10.7222C90.5916 10.7222 91.5458 10.9644 92.3643 11.4441C93.1783 11.9238 93.8051 12.5991 94.2356 13.47C94.6752 14.3409 94.8948 15.3516 94.8948 16.4973C94.8948 17.643 94.6752 18.6536 94.2356 19.5246C93.8005 20.3955 93.1783 21.0755 92.3643 21.5599C91.5503 22.0395 90.5916 22.2771 89.4923 22.2771ZM89.553 20.307C90.236 20.307 90.8067 20.1487 91.27 19.8366C91.7329 19.5246 92.084 19.0821 92.3132 18.5139C92.5469 17.9457 92.6592 17.2751 92.6592 16.502C92.6592 15.3097 92.388 14.3782 91.8407 13.7075C91.2933 13.0369 90.4889 12.6969 89.427 12.6969C88.7441 12.6969 88.1734 12.8553 87.7105 13.1673C87.2471 13.4793 86.8965 13.9218 86.6674 14.49C86.4332 15.0582 86.3213 15.7288 86.3213 16.502C86.3213 17.6942 86.5925 18.6257 87.1399 19.2964C87.6868 19.967 88.4916 20.307 89.553 20.307Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2265_11081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79.8913,
    height: 21,
    fill: "white",
    transform: "translate(15 6)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLido);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lido.8752d85f37e781bbacb7a1be3a6c9d28.svg";